var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 224.99 224.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "StoreIcons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.39,65.46a23.61,23.61,0,1,0,23.71,23.62A23.66,23.66,0,0,0,173.39,65.46Zm0,40.61a16.87,16.87,0,1,1,16.94-16.87A16.9,16.9,0,0,1,173.38,106.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.85,0H46.14A46.19,46.19,0,0,0,0,46.14V178.85A46.19,46.19,0,0,0,46.14,225H178.85A46.19,46.19,0,0,0,225,178.85V46.14A46.19,46.19,0,0,0,178.85,0Zm4.64,117.7L163,135.18a27,27,0,0,1-53,10.22l-50.7-17.14A23.74,23.74,0,1,1,68.09,104l49,16.56a27,27,0,0,1,18.64-8L143,90.32c0-.44-.07-.88-.07-1.32a30.52,30.52,0,1,1,40.52,28.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.11,123.78a18.22,18.22,0,0,0-4.05.47l10.08,3.41a13.1,13.1,0,1,1-12.41,23.07l-10.87-3.67a18,18,0,1,0,17.25-23.28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.24,92.63a16.64,16.64,0,1,0,4.9,32.56L42.2,122.5a13.1,13.1,0,1,1,12.4-23.07l5.24,1.77A16.71,16.71,0,0,0,45.24,92.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteam);
export default __webpack_public_path__ + "static/media/steam.2bdaf6fb9fac307c68b0266d51b56867.svg";
export { ForwardRef as ReactComponent };